<template>
  <div class="article__item" @click="redirectToArticle">
    <img class="article__thumbnail" :src="thumbnailUrl" :alt="title" />
    <span class="article__title">
      {{ title }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'ArticleItem',
  components: {},
  props: {
    id: {
      type: Number,
      default: 0,
      required: true,
    },
    slug: {
      type: String,
      default: '',
      required: true,
    },
    thumbnailUrl: {
      type: String,
      default: '',
      required: true,
    },
    title: {
      type: String,
      default: '',
      required: true,
    },
    settings: {
      required: true,
      default: () => ({
        watch_host: '',
        main_host: '',
        events_host: '',
      }),
      type: Object,
    },
  },
  methods: {
    redirectToArticle() {
      const url = this.getArticleUrl()
      window.open(url, '_blank').focus()
    },
    getArticleUrl() {
      const protocol = window.location.protocol
      const host = this.settings.main_host

      return `${protocol}//${host}/read/articles/${this.slug}`
    },
  },
}
</script>

<style lang="scss" scoped>
.article__item {
  flex: 1 0 50%;
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 64px;
  gap: 12px;
  margin-bottom: 16px;
  cursor: pointer;

  .article__thumbnail {
    width: 64px;
    height: 64px;
    border-radius: 2px;
  }

  .article__title {
    font-family: DM Sans, serif;
    font-size: 16px;
    max-width: 290px;
    font-weight: 500;
    line-height: 20px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #ffffff;
  }
}
</style>
